<template>
  <div  class="login_style">
    <div v-if="backgroundImg !='' && backgroundImg !='0'" class="background" >
      <img :src="backgroundImg" width="100%" height="100%" alt="" />
    </div>

      <div class="login_logo_img" v-show="logoImg != ''"><img :src="logoImg"/></div>
      <div class="login_logo_font">
        <div class="login_font_set logo_name">{{logoName}}</div>
        <div class="login_font_set logo_phone"><span v-if="pstnService.length>0">服务热线:</span>&nbsp;&nbsp;{{pstnService}}</div>
      </div>
      <div class="login_input_style" :style="templateStyle"><div class="login_btn"></div></div>
      <div class="template_input" :style="InputStyle">
        <div class="login_font">欢迎用户登录</div>
        <div class="btn_style">
          <div v-show="!disabled" class="img_login company_code"><img src="../../assets/image/companyCode.png"/></div>
          <Input v-model="companyId" placeholder="请输入企业编号" style="width: 250px;" v-show="!disabled"/>
        </div>
        <div class="btn_style">
          <div class="img_login agent_code"><img src="../../assets/image/agentCode.png"/></div>
          <Input v-model="username"  placeholder="请输入员工工号" style="width: 250px;"/>
        </div>
        <div class="btn_style">
          <div class="img_login password_code"><img src="../../assets/image/passWord.png"/></div>
          <Input v-model="password"  placeholder="请输入密码" type="password" style="width: 250px;"/>
        </div>
        <div class="btn_style" v-if="loginCount" style="line-height: 0px;height: auto;margin-top: 11px;">
          <Input v-model="identifyingCode" class="login_input" placeholder="请输右侧验证码"  style="width: 200px"/>
          <Identify :createCode="createCode" @changeValidateCode="getValidateCode"></Identify>
        </div>
        <div class="btn_style" style="line-height: 0px;height: 50px">
          <div class="remember_passWord"><Checkbox v-model="rememberPassWord"><div  class="check_font_style">记住密码</div></Checkbox></div>
        </div>
        <div class="btn_style btn_login_submit">
          <Button type="success"  @click="login" class="login_btn" style="margin-right: 112px" :loading="loading"><span v-if="!loading">登录</span><span v-else>登录...</span></Button>
        </div>
      </div>
      <footer class="footer_logo_font" :style="footerStyle">
        <span v-if="companyName != ''">{{companyName}}</span><span v-if="aboutMe != ''">|</span><a v-if="aboutMe != ''" :href="aboutMe" target="_blank">关于我们</a><span v-if="contactMe != ''">|</span><a v-if="contactMe != ''" :href="contactMe" target="_blank">联系我们</a><span v-if="companyHome != ''">|</span><a v-if="companyHome != ''" :href="companyHome" target="_blank">网站首页</a>
      </footer>
      <div class="video_bac" v-show="backgroundImg ==''">
        <video id='myVideo' class='video-js vjs-default-skin show_video' autoplay="autoplay" :style="videoHeight" loop="loop" preload='auto'>
          <source src="../../assets/image/loginVideo.mp4" type='video/mp4'/>
        </video>
      </div>
    </div>
</template>

<script>
  import Identify from '@/components/login/Identify.vue'
  export default {
    name: 'Login',
    components:{
      Identify
    },
    data () {
      return {
        logoTitle:'',
        logoName:'',
        pstnService:'',
        companyName:'',
        logoImg:'',
        aboutMe:'',
        contactMe:'',
        companyHome:'',
        username: '',
        companyId: '',
        password: '',
        identifyingCode: '',
        createCode: '',
        loading:false,
	      companyCode:'',
        disabled:false,
        player:null,
        footerStyle:{marginTop:''},
        videoHeight:{height:''},
        templateStyle:{marginTop:''},
        InputStyle:{marginTop:''},
        rememberPassWord: false,
        loginCount:false,
        options: {autoplay: true, muted: true, controls: false},
        valueDate:new Date().getTime(),
        backgroundImg:'0',//0默认不显示视频 
      }
  },

  methods: {
    login: function () {
      if (!this.companyId){
        this.$Message.info({
          title:'提示',
          content:"请输入企业编号!"
        });
        return false;
      }
      if (!this.username){
        this.$Message.info({
          title:'提示',
          content:"请输入员工编号!"
        });
        return false;
      }
      if (!this.password){
        this.$Message.info({
            title:'提示',
            content:"请输入密码!"
         });
        return false;
      }
      if (this.loginCount && this.createCode!=this.identifyingCode){
        this.$Message.info({
          title:'提示',
          content:"验证码错误请重新输入!",
        });
        this.getValidateCode();
        return false;
      }
      let that = this;
            let bros=that.checkBrowser();
      if ("Chrome" != bros) {
					alert("为了更好的操作体验，请您优先使用谷歌浏览器");
					return;
			}
      let param={
        agentNumber:this.username,
        employeePassword:this.password,
        companyCode:this.companyId,
        code:this.identifyingCode,
        value:this.valueDate,
      };
      this.loading=true;
      localStorage.setItem('loginSign',"0");
      this.$http.post("login/checkIsSameLogin.json",param).then(function (res) {
        let result = res.data.flag;
        let status=res.status;
        if(status!=200){
          that.loading=false;
          that.$Message.info("登录失败,请重新登录!");
          window.location.reload();
          return false
        }
        if (result ==  "000") {
          that.$Message.info("请输入验证码");
          that.getValidateCode();
          that.loading=false;
          return false
        }
        if (result != "666" && result != "111") {
          that.loading=false;
          that.$Message.error(res.data.msg);
          return false
        }
        if(result == "111"){
          that.loading=false;
          that.$Modal.confirm({
            title: '提示',
            content: "当前账号已在别处登录，请确认后操作",
            onOk: () => {
              that.loading=true;
              that.doLogin(param,"1");
            }
          });
          return;
        }
        that.doLogin(param,"0");
      })
    },
    //flag 用于标识是否是强挤的标志
    doLogin:function(param,flag){
      let that = this;
      let customerType=[];
      param.isSqueeze = flag;
      this.$http.post("login/doLogin.json",param).then(function (res) {
        that.loading=false;
        let status=res.status;
        if(status!=200){
          that.$Message.info("登录失败,请重新登录!");
          window.location.reload();
          return false
        }
        let result = res.data.flag;
        if (result ==  "000") {
          that.$Message.info("请输入验证码");
          that.getValidateCode();
          return false
        }
        if (result !=  "666") {
          that.$Message.error(res.data.msg);
          return false
        }
        if(res.data.obj.customerType){
          customerType=res.data.obj.customerType;
        }
        let list=res.data.obj.menuList;
        let menuList={};
        for (let i=0;i<list.length;i++){
          menuList[list[i]]=true;
        }
        if (that.rememberPassWord) {
          that.setCookie("account", that.username);
          that.setCookie("password", that.password);
          that.setCookie("companyId", that.companyId);
        }else{
          that.setCookie("account", "");
          that.setCookie("password", "");
          that.setCookie("companyId", "");
        }
        document.onkeydown = undefined;
        that.companyCode=res.data.obj.agentInfo.companyCode;
        if(!that.companyCode){
          that.companyCode=that.companyId;
        }
        that.initLoginArgument(res.data.obj);
        localStorage.setItem("signinStatus","0");
        localStorage.setItem("thirdPopupAddress",res.data.obj.thirdPopupAddress);
        localStorage.setItem('roleList', JSON.stringify(menuList));
        localStorage.setItem('companyId',that.companyCode);
        localStorage.setItem('token', res.data.obj.token);
        localStorage.setItem('companyLogo', res.data.obj.configInfo.companyLogo);
        localStorage.setItem('agentInfo',  JSON.stringify(res.data.obj.agentInfo));
        let configItem = res.data.obj.configInfo;
        configItem.isHiddenService = configItem.isHiddenService?configItem.isHiddenService:'0';
        configItem.screenShow = configItem.screenShow?configItem.screenShow:'0';
        localStorage.setItem('configInfo', JSON.stringify(configItem));
        localStorage.setItem('sendMessageFlag',  res.data.obj.sendMessageFlag);
        localStorage.setItem('phoneType', res.data.obj.agentInfo.phoneType);
        localStorage.setItem("outPhonePick",res.data.obj.agentInfo.externalAnswer);
        localStorage.setItem("autoSignIn", res.data.obj.agentInfo.autoSignIn);
        localStorage.setItem('customerType', JSON.stringify(customerType));

        localStorage.setItem("agentId",res.data.obj.agentInfo.agentId);
        localStorage.setItem("pstnNumber",res.data.obj.agentInfo.pstnNumber);
        localStorage.setItem("hangupAgentStatus",res.data.obj.agentInfo.agentStatus);
        localStorage.setItem("supportAI",res.data.obj.supportAI);
        localStorage.setItem("companyType",res.data.obj.companyType);//存储企业类型
        localStorage.setItem("registeredCertificate",res.data.obj.registeredCertificate);//注册证书                                                            //注册证书
        localStorage.setItem("externalPhoneAutoAnswer",res.data.obj.configInfo.externalPhoneAutoAnswer);//是否外置话机呼出自动接听
        //是否企业支持AI助手座席
        localStorage.setItem("supportAiAssistant",res.data.obj.supportAiAssistant);
        //是否企业支持视频座席
        localStorage.setItem("sysSupportVideo",res.data.obj.sysSupportVideo);
        //是否企业支持在线客服
        localStorage.setItem("sysSupportChat",res.data.obj.sysSupportChat);
        localStorage.setItem("batchDownloadRecordingFlag",res.data.obj.batchDownloadRecordingFlag);//录音批量下载                                                                            //录音批量下载
        localStorage.setItem("quickApply",JSON.stringify(res.data.obj.quickApply));//快速应用
        localStorage.setItem("valueTime"+param.companyCode+"_"+param.agentNumber,that.valueDate);//用于验证sso重复登录的时间戳
        //企业是否支持工单
        localStorage.setItem("sysSupportWorkOrder",res.data.obj.sysSupportWorkOrder);
        //企业是否开启工单类型且有数据
        localStorage.setItem("isOpenOrderType",res.data.obj.isOpenOrderType);

        that.$http.defaults.headers.Authorization="Bearer "+res.data.obj.token;
        that.$http.defaults.headers.companyCode=that.companyCode;
        that.loginCount = false;
        that.player.pause();  //暂停
        that.player.dispose() ; //销毁
        that.$router.push({path: '/index'});
        localStorage.setItem('loginName', that.username);
        that.registerPhone();
      })
    },
    checkBrowser:function(){
        let userAgent = navigator.userAgent;
        let isOpera = userAgent.indexOf("Opera") > -1;
        if (isOpera) {
          return "Opera"
        };
        if (userAgent.indexOf("Firefox") > -1) {
          return "FF";
        }
        if (userAgent.indexOf("Chrome") > -1){
          return "Chrome";
        }
        if (userAgent.indexOf("Safari") > -1) {
          return "Safari";
        }
        if (userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1 && !isOpera) {
          return "IE";
        }
    },
    getValidateCode:function(){
      let that = this;
      this.$http.get("common/validateCode.json?employeeCode="+this.username+"&companyCode="+this.companyId).then(function (res) {
        let count = res.data+'';
        that.loginCount = true;
        that.createRandom(count);
      })
    },
    reset: function () {
      this.username = '';
      this.password = '';
      this.component = '';
    },
    showVideo:function(){
        this.player= this.$video('myVideo', this.options, function onPlayerReady() {
        this.on('play', function() {
          // console.log('开始/恢复播放')
        });
        this.on('pause', function() {
          // console.log('暂停播放')
        });
        this.on('ended', function() {
          // console.log('结束播放')
        });
      });
      this.player.load();
      this.player.play();
    },
    initVideo:function () {
      let that=this;
      let Interval= setInterval(() =>{
        let myVideo=document.getElementById("myVideo");
        if(!myVideo){
          return false;
        }
        clearInterval(Interval);
        that.showVideo();
      },300);
    },
    createRandom:function (count) {
      this.createCode=count;
    },
    // 获取cookie
    getCookie: function (key) {
      if (document.cookie.length > 0) {
        let start = document.cookie.indexOf(key + '=');
        if (start !== -1) {
          start = start + key.length + 1;
          let end = document.cookie.indexOf(';', start);
          if (end === -1) end = document.cookie.length;
          return unescape(document.cookie.substring(start, end))
        }
      }
      return ''
    },
    // 保存cookie
    setCookie: function (name, value) {
      let exp = new Date();
      exp.setTime(exp.getTime() + 30*24*60*60*1000*12);
      document.cookie = name + "="+ escape (value) + ";expires=" + exp.toGMTString();
    },
    mountLogoHeight:function (reduceHeight) {
      let clientHeight=document.documentElement.clientHeight;
      let actualHeight=(clientHeight-reduceHeight)/2+'px';
      return actualHeight;
    }
  },
  created(){
    let account = this.getCookie("account");
    let password = this.getCookie("password");
    let companyId = this.getCookie("companyId");
    if (companyId && account && password){
      this.username = account;
      this.password = password;
      this.companyId = companyId;
      this.rememberPassWord = true;
    }
    let that = this;
    document.onkeydown = function(){
      let key = window.event.keyCode;
      if(key === 13){
        that.login()
      }
    };
    this.templateStyle.marginTop=this.mountLogoHeight(380);
    this.InputStyle.marginTop=this.mountLogoHeight(280);
    let clientHeight=document.documentElement.clientHeight;
    this.footerStyle.marginTop=(clientHeight-270)+150+'px';
    this.videoHeight.height=(clientHeight-270)+'px';
    let cacheCustomerList={};
    localStorage.setItem("cacheCustomerList",JSON.stringify(cacheCustomerList));
    localStorage.setItem("loginUrl",window.location.href);
  },
  mounted(){
    let param={
      journalType:"null",
      menuId:"null",
    };
    let that = this;
    this.$http.post("login/loginConfig.json",param).then(function (res) {
      let result=res.data.flag;
      if(result!="666"){
        that.$Modal.info({
          title:'提示',
          content:res.data.msg
        });
        return false;
      }
      that.disabled=false;
      let companyId=res.data.obj.companyCode;
      if(companyId){
         that.companyId=companyId;
         that.disabled=true;
      }
      that.initArgument(res.data.obj);
      let loginInfo=res.data.obj.loginInfo;
      for(let i=0;i<loginInfo.length;i++){
        let configKey=loginInfo[i].configKey;
        let configValue=loginInfo[i].configValue;
        if(configValue){
          if(configKey=='login_page_copyright'){
            that.companyName=configValue;
          }
          if(configKey=='login_page_service_tel'){
            that.pstnService=configValue;
          }
          if(configKey=='login_page_title'){
            that.logoName=configValue;
          }
          if(configKey=='login_about_me'){
            that.aboutMe=configValue;
          }
          if(configKey=='login_contact_me'){
            that.contactMe=configValue;
          }
          if(configKey=='login_domain'){
            that.companyHome=configValue;
          }
        }
        if(configKey=='login_page_logo'){
          if(configValue){
            that.logoImg="data:image/jpg;base64,"+configValue;
          }else{
            that.logoImg = require('@/assets/image/logo.png');
          }

        }
        if(configKey=='login_page_custom_bg'){
          if(configValue){
            that.backgroundImg="data:image/jpg;base64,"+configValue;
            //that.backgroundImg = require('@/assets/image/b.jpeg');
          }else{
            that.backgroundImg='';
          }
        }
      }
    });
    this.initVideo();
    this.loginCount=false;
  },
    destroyed(){
      document.onkeydown = undefined;
    },
    watch:{
      loading:function () {
        let that=this;
        setTimeout(function () {
          that.loading=false;
        },10000);
      }
    }
}
</script>

<style scoped lang="less">
.background{
    width:100%;  
    height:100%;
    z-index:-1;
    position: absolute;
}
</style>



// WEBPACK FOOTER //
// src/components/login/Login.vue